import { gql } from "@apollo/client";

export const GET_POS = gql`
  query GetPOs($customer_id: Int) {
    pos(customer_id: $customer_id) {
      _id
      po_number
      po_date
      balance_due
      total
      invoices {
        id
      }
    }
  }
`;
